import { observer } from 'mobx-react';
import * as React from 'react';
import { Redirect, RouteComponentProps, withRouter } from 'react-router';
import { FUTURE_SPEECHES_KEYWORD, SpeechesData } from '../stores';
import { Speeches } from './Speeches';

@(withRouter as ClassDecorator)
@observer
export class SpeechesByYear extends React.Component<{ data: SpeechesData, year: string } & Partial<RouteComponentProps<{}>>> {
    render() {
        const { data, year } = this.props;

        if (data.isLoading) return null;

        const speechData = data.byYear[year];

        if (!speechData || !speechData.length) {
            return <Redirect to='/talks' />;
        }

        return (
            <Speeches
                data={year === FUTURE_SPEECHES_KEYWORD
                    ? speechData.slice().reverse()
                    : speechData}
            />
        );
    }
}
